import { c as _c } from "react/compiler-runtime";
import { Button, Tooltip } from '@mui/material';
export const AddButton = t0 => {
  const $ = _c(7);
  const {
    onClick,
    disabled
  } = t0;
  const t1 = disabled ? undefined : "Add";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <i className="material-symbols-add-rounded w-[20px] h-[20px]" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== disabled || $[2] !== onClick) {
    t3 = <span><Button className="min-w-[20px]! p-[6px]" variant="contained" disabled={disabled} onClick={onClick}>{t2}</Button></span>;
    $[1] = disabled;
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <Tooltip title={t1}>{t3}</Tooltip>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};